import { render } from "./PartnersStandard.vue?vue&type=template&id=71c2ff7a"
import script from "./PartnersStandard.vue?vue&type=script&lang=js"
export * from "./PartnersStandard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__